import React, { useEffect, useState } from 'react';
import { useDataProvider, useNotify } from 'react-admin';
import { formatEnCaRange } from '../../../utils';
import Grid from '@material-ui/core/Grid';
import DataDistributionCard from '../../../Components/DataDistributionCard';
import { getRankingInfoTooltipDescription, getRankingInfoTooltipTitle } from '../utils';
import Spinner from '../../../Components/Spinner';
import NoData from './NoData';
import {
    PROSPECT_CONVERSION,
    PROSPECT_CONVERSION_MAIN_CARD_CONTENT_FIRST_SECTION, PROSPECT_CONVERSION_MAIN_CARD_CONTENT_SECOND_SECTION,
} from '../const';
import MetricTopCard from './MetricTopCard';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    description: {
        color: 'gray',
        fontSize: theme.spacing(2),
    },
}))

const ProspectConversion = ({ showLegend, range, serviceType }) => {
    const dataProvider = useDataProvider()
    const classes = useStyles()
    const notify = useNotify()

    const [questionsBreakdown, setQuestionsBreakdown] = useState(null)
    const [questionsStatsFetched, setQuestionsStatsFetched] = useState(false)
    const [prospectConversionData, setProspectConversionData] = useState(null)
    const [prospectStatsFetched, setProspectStatsFetched] = useState(false)

    useEffect(()=> {
        setProspectStatsFetched(false)
        setQuestionsStatsFetched(false)

        fetchProspectConversion()
        fetchQuestionsBreakdown()
    },[range, serviceType])


    const fetchQuestionsBreakdown = () => {
        const queryStringParams = formatEnCaRange(range)
        queryStringParams.service_type_id = serviceType
        queryStringParams.metric_id = 1

        dataProvider('GET_LIST', 'elevation/questions/breakdown', { queryStringParams })
            .then(res => {
                setQuestionsBreakdown(res.data)
                setQuestionsStatsFetched(true)
            })
            .catch((e) => {
                notify(e.message, 'warning')
            })
    }

    const fetchProspectConversion = () => {
        const queryStringParams = formatEnCaRange(range)
        queryStringParams.service_type_id = serviceType

        dataProvider('GET_ONE', 'elevation/scores/prospect-conversion', { queryStringParams })
            .then(res => {
                setProspectConversionData(res.data)
                setProspectStatsFetched(true)
            })
            .catch((e) => {
                notify(e.message, 'warning')
            })
    }

    if (!questionsStatsFetched || !prospectStatsFetched) {
        return <Spinner />
    }

    if (questionsBreakdown && questionsBreakdown.length !== 0 && prospectConversionData) {
        return (
            <Grid container spacing={3}>
                <MetricTopCard
                    value={prospectConversionData.prospect_conversion_score !== null ? `${Math.round(prospectConversionData.prospect_conversion_score)}%` : '-'}
                    subtitle={PROSPECT_CONVERSION}
                    description={
                        <>
                            <Typography className={classes.description}>{PROSPECT_CONVERSION_MAIN_CARD_CONTENT_FIRST_SECTION}</Typography>
                            <Typography className={classes.description}>{PROSPECT_CONVERSION_MAIN_CARD_CONTENT_SECOND_SECTION}</Typography>
                        </>
                    }
                    tooltipTitle={getRankingInfoTooltipTitle(prospectConversionData.prospect_conversion_rank_percent)}
                    tooltipDescription={getRankingInfoTooltipDescription(prospectConversionData.prospect_conversion_rank_percent)}
                    industryBreakdown={prospectConversionData.industry_breakdown ?? []}
                    helpdocLink={'https://support.vouchedfor.co.uk/en/articles/3273602'}
                    insightsDrawerButtonLink={`/elevation-client-answers/v2?metric_id=${1}&service_type_id=${serviceType}&to=${range.to.toLocaleDateString('en-CA')}&from=${range.from.toLocaleDateString('en-CA')}`}
                    drawerTitle='Prospect conversion'
                    reviewCount={prospectConversionData.review_count}
                />
                {questionsBreakdown.map((question) =>
                    <DataDistributionCard
                        key={`prospect-conversion-card-question-${question.question_id}`}
                        title={question.label_template}
                        subheader={question.review_count === undefined ? '' : `${question.review_count} ${question.review_count === 1 ? "review" : "reviews"}`}
                        dataDistributionSections={question.answers.filter(answer => answer.response_count && answer.score !== null)}
                        isPositiveMetric={true}
                        showLegend={showLegend}
                        tooltipTitle={getRankingInfoTooltipTitle(question.industry_rank_percent)}
                        tooltipDescription={getRankingInfoTooltipDescription(question.industry_rank_percent)}
                        helpdocLink={question.helpdoc_link}
                        insightsDrawerButtonLink={`/elevation-client-answers/v2?metric_id=${1}&service_type_id=${serviceType}&question_id=${question.question_id}&to=${range.to.toLocaleDateString('en-CA')}&from=${range.from.toLocaleDateString('en-CA')}`}
                        industryBreakdown={question.industry_breakdown ?? []}
                        reviewCount={question.review_count}
                    />
                )}
            </Grid>
        )
    }

    return <NoData statName="Prospect conversion" />
}

export default ProspectConversion